export const MODULE_LABELS = {
  submission: "Manuscript submission & pipeline tracking",
  messaging: "Team messaging",
  sales_summary: "Sales summary & lifetime totals",
  statements: "Downloadable royalty statements",
  documents: "Documents & copyright vault",
  sales_analytics: "Advanced sales analytics & charts",
  cover_design_brief: "Custom cover design briefs",
  loc_records: "Library of Congress records",
  priority_production: "Priority production queue",
  launch_kit: "Launch marketing kit",
  dedicated_support: "Dedicated support",
};

export const STAGES = [
  "submitted", "under_review", "editing", "design", "formatting", "ready_for_kdp", "uploaded_to_kdp", "live",
];

export const STAGE_LABELS = {
  draft: "Draft",
  submitted: "Submitted",
  under_review: "Under Review",
  editing: "Manuscript Prep",
  design: "Design",
  formatting: "Formatting",
  ready_for_kdp: "Ready to Publish",
  uploaded_to_kdp: "Publishing",
  live: "Live",
};

const STAGE_COLORS = {
  draft: "bg-neutral-100 text-neutral-600 border-neutral-200",
  submitted: "bg-blue-50 text-blue-700 border-blue-200",
  under_review: "bg-amber-50 text-amber-700 border-amber-200",
  editing: "bg-purple-50 text-purple-700 border-purple-200",
  design: "bg-pink-50 text-pink-700 border-pink-200",
  formatting: "bg-cyan-50 text-cyan-700 border-cyan-200",
  ready_for_kdp: "bg-indigo-50 text-indigo-700 border-indigo-200",
  uploaded_to_kdp: "bg-orange-50 text-orange-700 border-orange-200",
  live: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const StatusBadge = ({ status }) => (
  <span
    data-testid={`status-badge-${status}`}
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${STAGE_COLORS[status] || STAGE_COLORS.draft}`}
  >
    {STAGE_LABELS[status] || status}
  </span>
);

export const PipelineProgress = ({ status }) => {
  const idx = STAGES.indexOf(status);
  const pct = status === "draft" ? 0 : ((idx + 1) / STAGES.length) * 100;
  return (
    <div className="w-full">
      <div className="bg-neutral-100 rounded-full h-2 w-full overflow-hidden">
        <div
          className="bg-neutral-900 h-full rounded-full transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
      <p className="text-xs text-neutral-500 mt-1">
        {status === "draft" ? "Not yet submitted" : `Stage ${idx + 1} of ${STAGES.length} — ${STAGE_LABELS[status]}`}
      </p>
    </div>
  );
};

export const StatCard = ({ label, value, sub, testId }) => (
  <div data-testid={testId} className="bg-white border border-neutral-200 rounded-lg p-6">
    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-neutral-500">{label}</p>
    <p className="text-3xl font-bold text-neutral-900 mt-2 font-heading">{value}</p>
    {sub && <p className="text-sm text-neutral-500 mt-1">{sub}</p>}
  </div>
);

export const EmptyState = ({ title, subtitle, action, image }) => (
  <div className="bg-white border border-neutral-200 rounded-lg p-12 text-center">
    {image && <img src={image} alt="" className="w-48 h-32 object-cover rounded-md mx-auto mb-6" />}
    <h3 className="text-xl font-semibold text-neutral-900 font-heading">{title}</h3>
    <p className="text-neutral-500 mt-2 mb-6">{subtitle}</p>
    {action}
  </div>
);
